import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import { ALPHARD_IMG } from "@/lib/media";

// Appears shortly after load, lingers ~20s, then fades. Clicking jumps
// the guest straight to Isack for a fast transfer request.
export const AlphardPromoPopup = ({ onRequestTransfer }) => {
  const [visible, setVisible] = useState(false);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(showTimer);
  }, []);

  useEffect(() => {
    if (!visible || paused) return;
    const hideTimer = setTimeout(() => setVisible(false), 20000);
    return () => clearTimeout(hideTimer);
  }, [visible, paused]);

  const handleClick = () => {
    setVisible(false);
    onRequestTransfer("I'd like to book an airport transfer, please.");
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          className="fixed bottom-5 left-5 z-50 w-72 glass rounded-2xl overflow-hidden shadow-2xl shadow-black/60"
          data-testid="alphard-promo"
        >
          <button
            onClick={() => setVisible(false)}
            className="absolute top-2 right-2 z-10 w-7 h-7 rounded-full bg-black/50 text-white/80 flex items-center justify-center hover:bg-black/70 transition-colors"
            data-testid="alphard-close-btn"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="relative h-36 overflow-hidden">
            <img src={ALPHARD_IMG} alt="Luxury Toyota Alphard transfer" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ocean via-transparent to-transparent" />
            <span className="absolute bottom-2 left-3 text-[10px] uppercase tracking-[0.25em] text-gold bg-black/50 rounded-full px-2 py-0.5">Arrive in style</span>
          </div>
          <button onClick={handleClick} className="w-full text-left p-4 group" data-testid="alphard-cta">
            <p className="font-display text-lg text-foreground leading-tight">Private Alphard Transfer</p>
            <p className="text-xs text-muted-foreground mt-1">Airport pickup in minutes. Tap and tell Isack where to.</p>
            <span className="mt-3 inline-flex items-center gap-1.5 text-sm text-gold group-hover:gap-2.5 transition-all">
              Request now <ArrowRight className="w-4 h-4" />
            </span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
